import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres88e/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres88e/labels')
  },
  getIndex (searchParams) {
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      sendParams = {
        p_dtereq_st: (typeof searchParams.dtereqst.replace(/\//g, '') !== 'undefined' ? searchParams.dtereqst.replace(/\//g, '') : ''),
        p_dtereq_en: (typeof searchParams.dtereqen.replace(/\//g, '') !== 'undefined' ? searchParams.dtereqen.replace(/\//g, '') : '')
      }
      if (isMock) return generator(mocker.index())
      return instance().get(endpoint + '/hres88e/index', { params: sendParams })
    } else {
      return generator({
        total: 0,
        rows: []
      })
    }
  },
  getCreate (searchParams) {
    let dataParams = {
      p_codempid_query: searchParams.p_codempid_query,
      p_dtereq: searchParams.p_dtereq.replace(/\//g, '')
    }
    if (isMock) return generator(mocker.create())
    const params = dataParams.p_codempid_query + '/' + dataParams.p_dtereq
    return instance().get(endpoint + '/hres88e/create/' + params)
  },
  getDetail (searchParams) {
    let dataParams = {
      p_codempid_query: searchParams.p_codempid_query,
      p_dtereq: searchParams.p_dtereq.replace(/\//g, ''),
      p_numseq: searchParams.p_numseq
    }
    if (isMock) return generator(mocker.detail())
    const params = dataParams.p_codempid_query + '/' + dataParams.p_dtereq + '/' + dataParams.p_numseq
    return instance().get(endpoint + '/hres88e/detail/' + params)
  },
  getDropdowns () {
    if (isMock) return generator(mocker.dropdowns())
    return instance().get(endpoint + '/hres88e/dropdowns')
  },
  getLogical () {
    if (isMock) return generator(mocker.listFields())
    return instance().get(endpoint + '/hres88e/listFields')
  },
  getDetailCodjob (searchParams) {
    let dataParams = {
      p_codjob: searchParams.p_codjob
    }
    if (isMock) return generator(mocker.detailCodjob())
    const params = dataParams.p_codjob
    return instance().get(endpoint + '/hres88e/detailCodjob/' + params)
  },
  postDetailSave ({ detail, searchParams }) {
    let sendParams = {
      p_codempid_query: searchParams.p_codempid_query,
      p_dtereq: searchParams.p_dtereq,
      p_numseq: searchParams.p_numseq,
      codcomp: detail.codcomp,
      codpos: detail.codpos,
      codjob: detail.codjob,
      codempl: detail.codempmt,
      qtyreq: detail.qtyreq,
      amtincom: detail.amtincom,
      dtereqm: detail.dtereqm,
      flgrecut: detail.flgrecut,
      codrearq: detail.codrearq,
      desnote: detail.desnote,
      staappr: detail.staappr,
      numreqst: detail.numseq,
      v_syncond: detail.v_syncond.code,
      v_syncond1: detail.v_syncond1,
      flgjob: detail.flgjob,
      flgcond: detail.flgcond,
      v_year: detail.v_year,
      v_mth: detail.v_mth
    }
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres88e/update', sendParams)
  },
  postCancel (sendParams) {
    if (isMock) return generator(mocker.cancel())
    return instance().post(endpoint + '/hres88e/cancel', sendParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hres88e/index.js